// This file was auto-generated by generate_types in the remote crate.
// Do not edit manually.

// Electric row types
export type JsonValue = number | string | boolean | Array<JsonValue> | { [key in string]?: JsonValue } | null;

export type Project = { id: string, organization_id: string, name: string, color: string, created_at: string, updated_at: string, };

export type Notification = { id: string, organization_id: string, user_id: string, notification_type: NotificationType, payload: JsonValue, issue_id: string | null, comment_id: string | null, seen: boolean, dismissed_at: string | null, created_at: string, };

export type NotificationType = "IssueCommentAdded" | "IssueStatusChanged" | "IssueAssigneeChanged" | "IssueDeleted";

export type Workspace = { id: string, project_id: string, owner_user_id: string, issue_id: string | null, local_workspace_id: string, archived: boolean, files_changed: number | null, lines_added: number | null, lines_removed: number | null, created_at: string, updated_at: string, };

export type ProjectStatus = { id: string, project_id: string, name: string, color: string, sort_order: number, created_at: string, };

export type Tag = { id: string, project_id: string, name: string, color: string, };

export type Issue = { id: string, project_id: string, status_id: string, title: string, description: string | null, priority: IssuePriority, start_date: string | null, target_date: string | null, completed_at: string | null, sort_order: number, parent_issue_id: string | null, extension_metadata: JsonValue, created_at: string, updated_at: string, };

export type IssueAssignee = { issue_id: string, user_id: string, assigned_at: string, };

export type IssueFollower = { issue_id: string, user_id: string, };

export type IssueTag = { issue_id: string, tag_id: string, };

export type IssueDependency = { blocking_issue_id: string, blocked_issue_id: string, created_at: string, };

export type IssueComment = { id: string, issue_id: string, author_id: string, message: string, created_at: string, updated_at: string, };

export type IssueCommentReaction = { id: string, comment_id: string, user_id: string, emoji: string, created_at: string, };

export type IssuePriority = "urgent" | "high" | "medium" | "low";

export type WorkspacePrStatus = "open" | "merged" | "closed";

export type UserData = { user_id: string, first_name: string | null, last_name: string | null, username: string | null, };

// Shape definition interface
export interface ShapeDefinition<T> {
  readonly table: string;
  readonly params: readonly string[];
  readonly url: string;
  readonly _type: T;  // Phantom field for type inference
}

// Helper to create type-safe shape definitions
function defineShape<T>(
  table: string,
  params: readonly string[],
  url: string
): ShapeDefinition<T> {
  return { table, params, url, _type: null as unknown as T };
}

// Individual shape definitions with embedded types
export const PROJECTS_SHAPE = defineShape<Project>(
  'projects',
  ['organization_id'] as const,
  '/shape/projects'
);

export const NOTIFICATIONS_SHAPE = defineShape<Notification>(
  'notifications',
  ['organization_id', 'user_id'] as const,
  '/shape/notifications'
);

export const WORKSPACES_SHAPE = defineShape<Workspace>(
  'workspaces',
  ['project_id'] as const,
  '/shape/project/{project_id}/workspaces'
);

export const PROJECT_STATUSES_SHAPE = defineShape<ProjectStatus>(
  'project_statuses',
  ['project_id'] as const,
  '/shape/project/{project_id}/statuses'
);

export const TAGS_SHAPE = defineShape<Tag>(
  'tags',
  ['project_id'] as const,
  '/shape/project/{project_id}/tags'
);

export const ISSUES_SHAPE = defineShape<Issue>(
  'issues',
  ['project_id'] as const,
  '/shape/project/{project_id}/issues'
);

export const ISSUE_ASSIGNEES_SHAPE = defineShape<IssueAssignee>(
  'issue_assignees',
  ['project_id'] as const,
  '/shape/project/{project_id}/issue_assignees'
);

export const ISSUE_FOLLOWERS_SHAPE = defineShape<IssueFollower>(
  'issue_followers',
  ['project_id'] as const,
  '/shape/project/{project_id}/issue_followers'
);

export const ISSUE_TAGS_SHAPE = defineShape<IssueTag>(
  'issue_tags',
  ['project_id'] as const,
  '/shape/project/{project_id}/issue_tags'
);

export const ISSUE_DEPENDENCIES_SHAPE = defineShape<IssueDependency>(
  'issue_dependencies',
  ['project_id'] as const,
  '/shape/project/{project_id}/issue_dependencies'
);

export const ISSUE_COMMENTS_SHAPE = defineShape<IssueComment>(
  'issue_comments',
  ['issue_id'] as const,
  '/shape/issue/{issue_id}/comments'
);

export const ISSUE_COMMENT_REACTIONS_SHAPE = defineShape<IssueCommentReaction>(
  'issue_comment_reactions',
  ['issue_id'] as const,
  '/shape/issue/{issue_id}/reactions'
);

// All shapes as an array for iteration and factory building
export const ALL_SHAPES = [
  PROJECTS_SHAPE,
  NOTIFICATIONS_SHAPE,
  WORKSPACES_SHAPE,
  PROJECT_STATUSES_SHAPE,
  TAGS_SHAPE,
  ISSUES_SHAPE,
  ISSUE_ASSIGNEES_SHAPE,
  ISSUE_FOLLOWERS_SHAPE,
  ISSUE_TAGS_SHAPE,
  ISSUE_DEPENDENCIES_SHAPE,
  ISSUE_COMMENTS_SHAPE,
  ISSUE_COMMENT_REACTIONS_SHAPE,
] as const;

// Type helper to extract row type from a shape
export type ShapeRowType<S extends ShapeDefinition<unknown>> = S['_type'];

// Union of all shape types
export type AnyShape = typeof ALL_SHAPES[number];
